import Vue from "vue";
import Router from "vue-router";
import Login from "./views/Login.vue";
import Ivent_Home from "./views/Ivent_Home.vue";
import Product_Home from "./views/Product_Home.vue";
import About from "./views/About.vue";
import Terms from "./views/Terms.vue";
import How from "./views/How.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login
    },
    {
      path: "/ivent",
      name: "Ivent_Home",
      component: Ivent_Home
    },
    {
      path: "/product/:name/:id",
      name: "Product_Home",
      component: Product_Home
    },
    {
      path: "/about",
      name: "About",
      component: About
    },
    {
      path: "/terms",
      name: "Terms",
      component: Terms
    },
    {
      path: "/how",
      name: "How",
      component: How
    }
  ]
});
